
import { BehaviorSubject } from 'rxjs';
import { handleResponse } from '../_helpers';
import {localization} from '../../Frames/localization'
import {messageWindow} from '../../Elements/Snackbar/MessageWindow'


const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));
var messageAlert = {
    variant: "",
    message: "",
    open: false
}
export const authenticationService = {
    login,
    logout,
    logoutCookiesNotEqual,
    messageAlert,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue () { return currentUserSubject.value }
};

function login(login, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            username: login,
            password: password
          })
    };
    try{
         var user = fetch(`/api/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            if(JSON.stringify(user.data).indexOf("id")>0)
            {
                localStorage.setItem('currentUser', JSON.stringify(user));
                currentUserSubject.next(user);
                messageWindow.OpenMessage("success", localization.GetTranslate('Alert.login'))
               /* messageAlert.variant = "success";
                messageAlert.message = localization.GetTranslate('Alert.login');
                messageAlert.open = true;*/

                return (
                    user
                );
            }
            else
            {
                var data = JSON.stringify(user);
                var dataError  = JSON.parse(data);
                messageWindow.OpenMessage("error", localization.GetTranslate(dataError.error))
                /*messageAlert.variant = "error";
                messageAlert.message = dataError.error;
                messageAlert.open = true; */
                return (
                    null
                );
            }
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            
        });
        return user;
    }
    catch(e)
    {
        console.log('error', e); 
        return null;
    }
}
function logout() {
    // remove user from local storage to log user out
    const requestOptionsExit = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify("")
    };
    fetch(`/api/logout`, requestOptionsExit)
    .then(user => {
        messageWindow.OpenMessage("info", localization.GetTranslate('Alert.exit'))
        localStorage.removeItem('currentUser');
        currentUserSubject.next(null);
        return user;
    });  
}
function logoutCookiesNotEqual() {
    // remove user from local storage to log user out
    const requestOptionsExit = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify("")
    };
    fetch(`/api/logout`, requestOptionsExit)
    .then(user => {
        messageWindow.OpenMessage("info", localization.GetTranslate('Alert.CookiesNotEqual'))
        localStorage.removeItem('currentUser');
        currentUserSubject.next(null);
        return user;
    });  
}
